import React from "react";
import { formatNumber } from "utils/currencyFormat";

const CongNoBanHangTableRows = ({
  list,
  onThanhToanClick,
  hasThanhToanAccess,
  pageIndex,
  pageSize,
}) => {
  const formatPhoneNumber = (input) => {
    try {
      if (!input) return "";
      const str = input.split(";")[0].trim();
      if (str.length === 10)
        return str.replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3");
      if (str.length === 11)
        return str.replace(/(\d{4})(\d{3})(\d{4})/, "$1.$2.$3");
      return str;
    } catch (e) {
      return input;
    }
  };

  return (
    <>
      {list.map((item, index) => {
        return (
          <div
            className="custom-table-row"
            key={item.OrderID || index}
            style={{ minHeight: "50px" }}
          >
            <div
              className="custom-table-cell flex-basis-5 disk-mobile"
              style={{ justifyContent: "center", padding: 10 }}
            >
              <span className="mobile-column-name color7-bold">STT</span>
              <div className="center-wrapper word-break">
                <p className="text-center color7">
                  {(pageIndex - 1) * pageSize + index + 1}
                </p>
              </div>
            </div>
            <div
              className="custom-table-cell flex-basis-16"
              style={{ justifyContent: "center", padding: 10 }}
            >
              <span className="mobile-column-name color7-bold">Mã ĐH</span>
              <div className="center-wrapper word-break">{item.OrderCode}</div>
            </div>
            <div
              className="custom-table-cell flex-basis-25"
              style={{
                justifyContent: "flex-start",
                lineHeight: "1.5",
                padding: 10,
              }}
            >
              <span className="mobile-column-name color7-bold">Khách hàng</span>
              <div className="center-wrapper word-break">
                {item.CustomerName}
                {item.CustomerPhone ? (
                  <>
                    <br />
                    (ĐT:{formatPhoneNumber(item.CustomerPhone)})
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div
              className="custom-table-cell flex-basis-15"
              style={{ justifyContent: "flex-end", padding: 10 }}
            >
              <span className="mobile-column-name color7-bold">Tổng tiền</span>
              <div
                className="center-wrapper color-do-bold text-right word-break"
                style={{ justifyContent: "flex-end" }}
              >
                {formatNumber(item.TotalAmount)}
              </div>
            </div>
            <div
              className="custom-table-cell flex-basis-15"
              style={{ justifyContent: "flex-end", padding: 10 }}
            >
              <span className="mobile-column-name color7-bold">Đã trả</span>
              <div
                className="center-wrapper color-do-bold text-right word-break"
                style={{ justifyContent: "flex-end" }}
              >
                {formatNumber(item.TotalPaid)}
              </div>
            </div>
            <div
              className="custom-table-cell flex-basis-15"
              style={{ justifyContent: "flex-end", padding: 10 }}
            >
              <span className="mobile-column-name color7-bold">Còn nợ</span>
              <div
                className="center-wrapper color-do-bold text-right word-break"
                style={{ justifyContent: "flex-end" }}
              >
                {formatNumber(item.ConNo)}
              </div>
            </div>
            <div
              className="custom-table-cell flex-basis-6"
              style={{ justifyContent: "center", padding: 10 }}
            >
              <div className="center-wrapper text-center word-break">
                {hasThanhToanAccess && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <a
                      title="Thanh toán"
                      onClick={() => onThanhToanClick(item.OrderID)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/app-assets/images/icon-thanh-toan-v2.png"
                        className="icon-button-v2"
                        alt="Thanh toán"
                      />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

const CongNoBanHangTable = ({
  list,
  TotalAmount,
  TotalPaid,
  TotalSub,
  onThanhToanClick,
  Total,
  hasThanhToanAccess,
  pageIndex,
  pageSize,
}) => {
  if (!list || list.length === 0) {
    return (
      <div className="custom-table-row">
        <div
          className="custom-table-cell text-center red"
          style={{ width: "100%" }}
        >
          Không có dữ liệu
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="Left808x200 Table-main-new css-table-ds">
        <div className="table-mobile table-mobile-hover">
          <div
            className="custom-table-wrapper"
            style={{ overflowX: "auto", width: "100%" }}
          >
            <div
              className="table-headers word-break"
              style={{ alignItems: "stretch" }}
            >
              <div
                className="custom-table-header flex-basis-5 disk-mobile"
                style={{ justifyContent: "center" }}
              >
                <p>
                  STT
                  <br />
                  <span className="color-do-bold font-size-12">[{Total}]</span>
                </p>
              </div>
              <div className="custom-table-header flex-basis-16">
                <p>Mã đơn hàng</p>
              </div>
              <div
                className="custom-table-header flex-basis-25"
                style={{ justifyContent: "flex-start" }}
              >
                <p>Tên khách hàng</p>
              </div>
              <div
                className="custom-table-header flex-basis-15 text-right"
                style={{ justifyContent: "flex-end" }}
              >
                <p>
                  Tổng tiền <br />{" "}
                  <span className="color-do-bold">
                    {formatNumber(TotalAmount)}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-15 text-right"
                style={{ justifyContent: "flex-end" }}
              >
                <p>
                  Đã trả <br />{" "}
                  <span className="color-do-bold">
                    {formatNumber(TotalPaid)}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-15 text-right"
                style={{ justifyContent: "flex-end" }}
              >
                <p>
                  Còn nợ <br />{" "}
                  <span className="color-do-bold">
                    {formatNumber(TotalSub)}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-6 text-center"
                style={{ justifyContent: "center" }}
              >
                <p>Thao tác</p>
              </div>
            </div>

            <div className="custom-table-body">
              <CongNoBanHangTableRows
                list={list}
                onThanhToanClick={onThanhToanClick}
                hasThanhToanAccess={hasThanhToanAccess}
                pageIndex={pageIndex}
                pageSize={pageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CongNoBanHangTable;
